//* 코치 마이페이지 관련 API
//  2025.01.27
//  희문

import * as BaseApi from "api/Base.api";
import { ITerms } from "api/interfaces/app.interface";

const BASE_URL = "/koach/v2/my";

export interface INoticeContent {
    id: number;
    noticeId: number;
    title: string;
    languageCode: string;
}

export interface INoticeItem {
    createdAt: string;
    contents: INoticeContent[];
}

export interface IGetMyInfoResponse {
    info: {
        hasVerifiedEmail: boolean;
        username: string;
        userKoachInfo: {
            cellphone: string;
            contact: string | null;
            contactTypeCode: string | null;
            countryPhoneCode: string;
            isActive: boolean;
            name: string | null;
            firstName: string | null;
            lastName: string | null;
            contactTypeInfo?: {
                names: string[];
            } | null;
            countryCode: string;
            countryInfo?: {
                code: string;
                names: string[];
            } | null;
            koachTypeCode: string | null;
            koachTypeInfo?: {
                code: string;
                names: string[];
            } | null;
        },
        termsList: ITerms[];
        noticeList: INoticeItem[];
    },
}

//* 마이페이지 정보 요청
//  2025.01.27
//  희문
export const getMyInfo = async (): Promise<IGetMyInfoResponse> => {
    console.log('api/koach/v2/my.api:getMyInfo')
    const url = `${BASE_URL}/`;
    return await BaseApi.get(url);
};

// 계정 활성화
export const toggleActiveAccount = async () => {
    console.log('api/koach/v2/my.api:toggleActiveAccount')
    const url = `${BASE_URL}/is-active/toggle`;
    return await BaseApi.patch(url, null);
};

//* 휴대전화 정보 요청
//  2025.01.27
//  희문
export const getCellphone = async () => {
    console.log('api/koach/v2/my.api:getCellphone')
    const url = `${BASE_URL}/cellphone`;
    return await BaseApi.get(url);
};

//* 연락처 정보 요청
//  2025.01.27
//  희문
export const getContactInfo = async () => {
    console.log('api/koach/v2/my.api:getContactInfo')
    const url = `${BASE_URL}/contact`;
    return await BaseApi.get(url);
};

//* 연락처 정보 수정
//  2025.01.27
//  희문
//* Params
//  newContactTypeCode: string
//  newContact: string
export const updateContactInfo = async (newContactTypeCode: string, newContact: string) => {
    console.log('api/koach/v2/my.api:updateContactInfo')
    const url = `${BASE_URL}/contact`;
    return await BaseApi.put(url, { newContactTypeCode, newContact });
};
